import React from 'react'

const ArchitectYourNextHeader = () => {
    return (
        <header id="homePage_the_next--header"
            className="container container80
                pv4-00 
                tc"
        >
            <h2 className="f3-00"
            >
                The Next
            </h2>
            <p className="tc f1-50">
                We bring you powerful advantages to architect your next digital transformation.
            </p>
            <p className="tc f1-50">
                The mission of KDA Design Technologies is simple: to partner with individuals, businesses, and organizations ready to embrace digital transformation.
            </p>
        </header>
    )
}

export default ArchitectYourNextHeader